import { useEffect } from "react";
import { useLang } from "@/context/LanguageContext";

const SEO_BY_LANG = {
  en: {
    title: "Tandem Paragliding in Costa Rica | Rivas & Dominical",
    description:
      "Book a tandem paragliding flight in Costa Rica (Rivas de Pérez Zeledón, Playa Dominicalito, Uvita Whale Tail) and Brazil . Certified pilots, insured flights, from $120. Instant online booking.",
    ogLocale: "en_US",
    htmlLang: "en",
    ogImage: "https://ik.imagekit.io/paraglidetour/parapente_costarica_puravida/tandem_paragliding_costarica_puravida_tour_pz.png",
  },
  es: {
    title: "Vuelo en Parapente Tándem Perez Zeledon y Dominical",
    description:
      "Reserva tu vuelo en parapente biplaza en Costa Rica (Rivas de Pérez Zeledón, Playa Dominicalito, Cola de Ballena en Uvita) y Brasil (Caraguatatuba). Pilotos certificados, vuelos asegurados, desde $120. Reserva online al instante.",
    ogLocale: "es_CR",
    htmlLang: "es",
    ogImage: "https://ik.imagekit.io/paraglidetour/parapente_costarica_puravida/tandem_paragliding_costarica_puravida_tour_pz.png",
  },
  pt: {
    title: "O Melhor Voo Duplo em Parapente no Brasil | Praia Martim de Sá, Caraguatatuba - SP",
    description:
      "Agende seu voo duplo de parapente na Praia Martim de Sá em Caraguatatuba. Pilotos certificados, voos com seguro, a partir de R$300,00. Reserva online instantânea.",
    ogLocale: "pt_BR",
    htmlLang: "pt-BR",
    ogImage: "https://ik.imagekit.io/paraglidetour/parapente_costarica_puravida/tandem_paragliding_costarica_puravida_tour_pz.png",
  },
};
//
const setMeta = (attr, key, value) => {
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", value);
};

export default function SEO() {
  const { lang } = useLang();

  useEffect(() => {
    const cfg = SEO_BY_LANG[lang] || SEO_BY_LANG.en;
    document.title = cfg.title;
    document.documentElement.lang = cfg.htmlLang;
    setMeta("name", "description", cfg.description);
    setMeta("property", "og:title", cfg.title);
    setMeta("property", "og:description", cfg.description);
    setMeta("property", "og:locale", cfg.ogLocale);
    setMeta("property", "og:image", cfg.ogImage);
    setMeta("name", "twitter:title", cfg.title);
    setMeta("name", "twitter:description", cfg.description);
    setMeta("name", "twitter:image", cfg.ogImage);
    
  }, [lang]);

  return null;
}